import { render, staticRenderFns } from "./salary.vue?vue&type=template&id=46f8622d&scoped=true"
import script from "./salary.vue?vue&type=script&lang=js"
export * from "./salary.vue?vue&type=script&lang=js"
import style0 from "./salary.vue?vue&type=style&index=0&id=46f8622d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f8622d",
  null
  
)

export default component.exports